import React from 'react'

const AccessDeniedView = () => {
  return (
    <div data-testid='accessDenied'>
      <h1>Whoops!</h1>
      <h3>{'You don\'t have the right permissions to view this page.'}</h3>
    </div>
  )
}

export default AccessDeniedView